import isPlaywright from "src/constants/isPlaywright";
import SystemInfo from "src/constants/SystemInfo";
import { getDeviceStore } from "src/stores/useDeviceStore";
import canNativeShare from "../canNativeShare";

let shouldShowSaveTutorial = false;
try {
	shouldShowSaveTutorial =
		SystemInfo.OS === "ios" &&
		!isPlaywright &&
		canNativeShare &&
		getDeviceStore().device === "mobile";
} catch (err) {
	shouldShowSaveTutorial = false;
}
export default shouldShowSaveTutorial;
